import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const WalkthroughProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

WalkthroughProduct.fragment = gql`
  fragment WalkthroughProduct on WalkthroughProduct {
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url}
        }
      }
    }
  }
`

export default WalkthroughProduct
